var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:!_vm.wide ? 'slide--vertical' : ''},[_c('h1',{staticClass:"mb-xl-5"},[_vm._v(_vm._s(_vm.title))]),(_vm.description !== '')?_c('h3',[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }